import KeepAlive from "react-activation"
import { useLocation, useNavigate } from "react-router-dom"
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from "shj-components"
import config from './config.json';
import { useCallback, useRef, useState } from "react";
import { message } from "antd";
import AddAndEdit from "./addAndEdit";
import { deleteServiceNodeConfigById, findServiceNodeConfig } from "@/services/serviceConfig";
import { authDict } from "shj-utils";
import { CopyModal } from "./copyModal";

const NodeList = () => {
    const listRef = useRef<any>();
    const history = useNavigate()
    const [detailInfo, setDetailInfo] = useState<any>();
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const fetchList = (values: any) => {
        return new Promise(async (resolve, reject) => {
            try {
                const { current, pageSize, query, ...rest } = values;
                findServiceNodeConfig(current, pageSize, query).then(data => {
                    resolve(data)
                })
            } catch (e) {
                reject({ success: false });
            }
        });
    };
    const onAdd = () => {
        setDetailInfo({})
        setVisibleDrawer(true)
    }
    const toEdit = (value) => {
        setDetailInfo(value)
        setVisibleDrawer(true)
    }
    const closeDetails = () => {
        setVisibleDrawer(false)
    }
    const reloadList = () => {
        listRef.current?.reload()
    }
    const onDelete = (id) => {
        const dialog = SMessage.delete({
            onOk: async () => {
              try {
                const res: any = await deleteServiceNodeConfigById(id)
                if (res.errorCode === 0) {
                  message.success('删除成功');
                  listRef.current.reload();
                } else {
                  message.error('删除失败');
                }
              } catch (err) {
                console.log(err)
              }
              dialog?.destroy();
            },
            onCancel: () => {
              message.warning('取消删除');
              dialog?.destroy();
            },
          });
    };
    const onCopy = useCallback(
        (record) => {
          CopyModal({
            fn: () => {
              listRef.current?.reload();
            },
            title: '复制',
            record
          });
        },
        [],
    );

    const extension = {
        request: { fetchList },
        events: { onAdd },
        searchFormConfig: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        },
        customRender: {
            codeRender(text, record: any) {
                return authDict['customerConfigDetail'] ? (
                    <div
                        onClick={() => toDetail(record)}
                        style={{ color: '#1677ff', cursor: 'pointer' }}
                    >
                        {text}
                    </div>
                ) : (
                    <div>{text}</div>
                )
            },
            nodeStatusRender(text: any, record: any) {
                return <span>{record.enabled ? '启用' : '禁用'}</span>;
            },
            setAction(text: any, record: any) {
                return <STableActions>
                    <SActionBtn
                        auth={'customerConfigDel'}
                        danger 
                        onClick={() => onDelete(record.id)}>
                        删除
                    </SActionBtn>
                    <SActionBtn
                        auth={'customerConfigCopy'}
                        onClick={() => onCopy(record)}
                    >
                        复制
                    </SActionBtn>
                    <SActionBtn
                        auth={'customerConfigEdit'}
                        onClick={() => {
                            toEdit(record);
                        }}
                    >
                        编辑
                    </SActionBtn>
                </STableActions>;
            },
        },
    };
    const toDetail = (record) => {
        history('/config/serviceConfig/serviceManage/detail/' + record.id);
    };
    return <>
        <SBack title={`节点管理`}></SBack>
        <SLowcodeList
            config={config}
            ref={listRef} {...extension} searchMode="group" />
        <AddAndEdit record={detailInfo} visibleDrawer={visibleDrawer} closeDetails={closeDetails} reloadList={reloadList}></AddAndEdit>
    </>
}
export default (props: any) => {
    const location = useLocation()
    return (
        <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
            <NodeList {...props} />
        </KeepAlive>
    )
}